import { render, staticRenderFns } from "./TabSucursales.vue?vue&type=template&id=3120c86d&scoped=true&"
import script from "./TabSucursales.vue?vue&type=script&lang=js&"
export * from "./TabSucursales.vue?vue&type=script&lang=js&"
import style0 from "./TabSucursales.vue?vue&type=style&index=0&id=3120c86d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120c86d",
  null
  
)

export default component.exports